import { render, staticRenderFns } from "./Form2_Persona.vue?vue&type=template&id=8d357d9a"
import script from "./Form2_Persona.vue?vue&type=script&lang=js"
export * from "./Form2_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d357d9a')) {
      api.createRecord('8d357d9a', component.options)
    } else {
      api.reload('8d357d9a', component.options)
    }
    module.hot.accept("./Form2_Persona.vue?vue&type=template&id=8d357d9a", function () {
      api.rerender('8d357d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/FUCEREP/Form2_Persona.vue"
export default component.exports